import { render, staticRenderFns } from "./UserDatasets.vue?vue&type=template&id=7ddf0930"
import script from "./UserDatasets.vue?vue&type=script&lang=js"
export * from "./UserDatasets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports